export {default} from './OrdersSummaryCard.connect';
